import axios, { AxiosResponse } from 'axios';

const api_endpoints: { [key: string]: { [key: string]: string } } = {
  eu: {
    dev: 'https://api-dev.wiz.world',
    uat: 'https://api-uat.wiz.world',
    pro: 'https://api.wiz.world',
    stg: 'https://api-stg.wiz.world',
  },
  cn: {
    dev: 'https://api-dev.wizconnected.cn',
    pro: 'https://api.wizconnected.cn',
  },
};

async function requestEncryptedSSIDAndPassword(
  ssid: string,
  password: string,
  accessToken: string,
  env: string,
  region: string | undefined,
  thirdParty: string | undefined
): Promise<AxiosResponse<string>> {
  if (region == undefined) {
    region = 'eu';
  }
  return new Promise<AxiosResponse<string>>(async (resolve, reject) => {
    const timeStart = new Date().getTime();
    const block = async () => {
      const now = new Date().getTime();
      if (now - timeStart > 30000) {
        window.clearInterval(token);
        reject(new Error('Timeout'));
      }
      const source = axios.CancelToken.source();
      setTimeout(() => {
        source.cancel();
      }, 4000);
      try {
        const res = await axios.post<string>(
          getUrlForEncryptingCredentials(env, region, thirdParty),
          {
            wifi_ssid: ssid,
            wifi_password: password.slice(0, password.length / 2),
          },
          {
            headers: { Authorization: `Bearer ${accessToken}` },
            cancelToken: source.token,
          },
        );
        if (res.data) {
          window.clearInterval(token);
          resolve(res);
        }
      } catch (e) {
        console.log(`Failed to encrypt the credentials because of ${e}`)
      }
    };
    block();
    const token = window.setInterval(block, 3000);
  });
}

async function createLightInCloud(
  homeId: number,
  roomId: number,
  name: string,
  macAddress: string,
  ip: string,
  env: string,
  region: string | undefined,
  accessToken: string,
  thirdParty: string | undefined
): Promise<AxiosResponse<string>> {
  if (region == undefined) {
    region = 'eu';
  }
  return new Promise<AxiosResponse<string>>(async (resolve, reject) => {
    const timeStart = new Date().getTime();
    const block = async () => {
      const now = new Date().getTime();
      if (now - timeStart > 30000) {
        window.clearInterval(token);
        reject(new Error('Timeout'));
      }
      const source = axios.CancelToken.source();
      setTimeout(() => {
        source.cancel();
      }, 10000);

      try {
        const res = await axios.post<string>(
          getUrlForCreatingLight(env, region, thirdParty),
          {
            home_id: homeId,
            room_id: roomId,
            name,
            mac_address: macAddress,
            ip,
          },
          {
            headers: { Authorization: `Bearer ${accessToken}` },
            cancelToken: source.token,
          },
        );
        if (res.data) {
          window.clearInterval(token);
          resolve(res);
        }
      } catch (e) {
        console.log(`Failed to create the light because of ${e}`)
      }
    };
    const token = window.setInterval(block, 11000);
  });
}

// we also starting opening the AP pairing framework
// to the selected third-parties
// this case the endpoints are different and should include the third party name
//
function getUrlForEncryptingCredentials(env: string,
  region: string | undefined,
  thirdParty: string | undefined): string {

  if (thirdParty != undefined) {
    return `${api_endpoints[region!][env]}/api/v2/thirdparty/${thirdParty}/ap-encrypt-password`;
  } else {
    return `${api_endpoints[region!][env]}/api/v2/utility/ap-encrypt-password`
  }
}

function getUrlForCreatingLight(env: string,
  region: string | undefined,
  thirdParty: string | undefined): string {
  if (thirdParty != undefined) {
    return `${api_endpoints[region!][env]}/api/v2/thirdparty/${thirdParty}/provision-device`;
  } else {
    return `${api_endpoints[region!][env]}/api/v2/light`
  }
}

export { requestEncryptedSSIDAndPassword, createLightInCloud };



// WEBPACK FOOTER //
// ./src/helpers/apiManager.ts